import instance from "../axiosConfig";
import { CreatedUserResponse, CreateUser, User, UserRole } from "./models";

export class UsersService {
    getUsers = async (): Promise<User[]> => {
        const response = await instance.get<User[]>(`api/Admin/Users`);

        return response.data;
    };

    getUser = async (id: string): Promise<User> => {
        const response = await instance.get<User>(`api/Admin/Users/${id}`);

        return response.data;
    };

    createUser = async (body: CreateUser): Promise<CreatedUserResponse> => {
        const response = await instance.post<CreatedUserResponse>(`api/Admin/Users`, body, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    };

    updateUser = async (id: string, body: { name: string; email: string }) => {
        try {
            const response = await instance.put<boolean>(`api/Admin/Users/${id}`, body, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            return response.status >= 200 && response.status < 300;
        } catch {
            return false;
        }
    };

    getRoles = async (): Promise<UserRole[]> => {
        const response = await instance.get<UserRole[]>(`api/Admin/Roles`);

        return response.data;
    };

    getUserRoles = async (userId: string): Promise<UserRole[]> => {
        const response = await instance.get<UserRole[]>(`api/Admin/Users/${userId}/Roles`);

        return response.data;
    };

    assignRoles = async (userId: string, roles: string[]): Promise<boolean> => {
        try {
            const response = await instance.post<boolean>(
                `api/Admin/Users/${userId}/AssignRoles`,
                { roles },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.status >= 200 && response.status < 300;
        } catch {
            return false;
        }
    };

    removeRoles = async (userId: string, roles: string[]): Promise<boolean> => {
        try {
            const response = await instance.post<boolean>(
                `api/Admin/Users/${userId}/RemoveRoles`,
                { roles },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.status >= 200 && response.status < 300;
        } catch {
            return false;
        }
    };

    blockUser = async (userId: string): Promise<boolean> => {
        try {
            const response = await instance.post<boolean>(`api/Admin/Users/${userId}/Block`);

            return response.status >= 200 && response.status < 300;
        } catch {
            return false;
        }
    };

    unblockUser = async (userId: string): Promise<boolean> => {
        try {
            const response = await instance.post<boolean>(`api/Admin/Users/${userId}/Unblock`);

            return response.status >= 200 && response.status < 300;
        } catch {
            return false;
        }
    };
}
